export const CREATE_FILTER_PRESET_MODAL_POSTFIX = '_CREATE_FILTER_PRESET_MODAL';
export const SAVE_FILTER_PRESET_MODAL_POSTFIX = '_SAVE_FILTER_PRESET_MODAL';
export const DELETE_FILTER_PRESET_MODAL_POSTFIX = '_DELETE_FILTER_PRESET_MODAL';

export const CREATE_FILTER_PRESET_FORM_POSTFIX = '_CREATE_FILTER_PRESET_FORM';
export const SAVE_FILTER_PRESET_FORM_POSTFIX = '_SAVE_FILTER_PRESET_FORM';
export const DELETE_FILTER_PRESET_FORM_POSTFIX = '_DELETE_FILTER_PRESET_FORM';
